import { Container } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import Breadcrumbs from 'src/components/Common/Breadcrumb';
import TaskDetails from "src/modules/data-protection/components/RisksAndTasks/tasks/details";

const EmployeeTaskDetail = ({
    t,
    history,
    match: {
        params
    }
}) => {
    return (
        <div className='page-content'>
            <Container fluid>
                <Breadcrumbs
                    title={t('Task details')}
                    breadcrumbItems={[
                        { title: 'SIP', link: '/' },
                        { title: 'My Tasks', link: '/employee/data-protection/tasks' },
                        { title: 'Details', link: '#' }
                    ]} 
                />

                <div className='bg-white p-4 mb-4'>
                    <TaskDetails
                        taskId={params?.id}
                        onBackClicked={() => {
                            history.push('/employee/data-protection/tasks')
                        }}
                        canUserEdit={false}
                        onRelatedTaskClicked={(id) => {
                            history.push(`/employee/data-protection/tasks/${id}`)
                        }}
                    />
                </div>
            </Container>
        </div>
    )
}

export default withNamespaces()(
    withRouter(
        EmployeeTaskDetail
    )
);
